export enum Basketball3x3EventDetailId {
  // TODO: change common detail ids to `CommonEventDetailId`
  PeriodLength = 16,
  TimerDirection = 124,
  PossessionTimeLimit = 177,
  TossWinner = 238,
  StartWithABall = 243,
}
